import moment from 'moment';
import * as excel from 'exceljs';
import { saveAs } from 'file-saver';
import {
	Orderstatus,
	Ordertype,
	Paymentmode,
	VendorApprovalStatus,
	orderType
} from '../enum';
import secureLocalStorage from 'react-secure-storage';
export const setToken = (key: string, value: string) => {
	return Promise.resolve().then(() => secureLocalStorage.setItem(key, value));
};

export const getToken = (key: string) => {
	return secureLocalStorage.getItem(key) || '';
};

export const removeToken = (key: string) => {
	// return localStorage.removeItem(key);
	return Promise.resolve().then(() => secureLocalStorage.removeItem(key));
};

export const valiadteToken = () => {
	const token = getToken('login-auth-token');
	const time = parseInt((getToken('exp') as string) || '0');
	const ctime = new Date().getTime(); // parseInt( getToken("exp"));
	const isLoggedIn = getToken('isLoggedIn');
	// if (manage) {
	if (time > ctime) {
		if (token && isLoggedIn) {
			return true;
		}
	}
	// }

	return false;
};

export const getAPIEndPoint = (endPoint: string, pageNumber: number, isSort = false) => {
	if (pageNumber > 0 && !isSort) {
		return `${endPoint}?page=${pageNumber}&perPage=${process.env.REACT_APP_RECORDS_PER_PAGE}`;
	} else if (pageNumber > 0 && isSort) {
		return `${endPoint}&page=${pageNumber}&perPage=${process.env.REACT_APP_RECORDS_PER_PAGE}`;
	}
	// console.log('endPoint', endPoint);

	return endPoint;
};

export const isNotObjectEmpty = (obj: any) => {
	return Object.keys(obj).length > 0 ? true : false;
};

export const formatDate = (dateJson: any, format = 'YYYY-MM-DD') => {
	const date = new Date(dateJson);
	return moment(date).format(format);
};

export function get_url_extension(fileName: string) {
	if (fileName != undefined && fileName != null && fileName != '') {
		const extension = fileName.split('.').pop();
		return extension || '';
	}
	return '';
}

export function getFileName(fileURL: any) {
	if (fileURL != undefined && fileURL != null && fileURL != '') {
		const filename = fileURL.split('/').pop(); // url.substring(url.lastIndexOf('/') + 1);
		return filename || '';
	}
	return '';
}

export const RemoveHashTag = (inputString: string) => {
	return inputString.replace(/#/g, '') || '';
};

export const handleDownload = (fileUrl: any, fileName: any) => {
	// Create a temporary anchor element
	const link = document.createElement('a');
	link.href = fileUrl;
	link.download = fileName || 'file';
	// link.target = '_blank';

	// Append the anchor to the DOM and trigger the download
	document.body.appendChild(link);
	link.click();

	// Clean up the temporary anchor
	document.body.removeChild(link);
};

//Get Date and Time in A Particaular format
export const formatDateTime = (dateJson: any, format = 'DD-MM-YYYY hh:mm A') => {
	const date = new Date(dateJson);
	return moment(date).format(format);
};

export const getNotificationType = (type: number) => {
	switch (type) {
		case 1:
			return 'allCustomers';
		case 2:
			return 'allDrivers';
		case 3:
			return 'selectedCustomers';
		case 4:
			return 'selectedDrivers';
	}
};

export const validateImageUrls = (documentUrls: string) => {
	const isImage =
		documentUrls.includes('data:image/jpeg') ||
		documentUrls.includes('data:image/png') ||
		documentUrls.includes('data:image/jpg');

	return isImage;
};

/**
 * download csv and excel
 */
const CustomerHeaders = [
	{ label: 'User Name', key: 'user_full_name' },
	{ label: 'Mobile Number', key: 'user_mobile_number' },
	{ label: 'Email Id', key: 'user_email' },
	{ label: 'No. of Orders', key: 'TotalOrders' },
	{ label: 'Registration Date', key: 'user_created_at' },
	{ label: 'Customer Status', key: 'user_is_active' }
];

const DriverHeader = [
	{ key: 'Make', label: 'Make' },
	{ key: 'Model', label: 'Model' },
	{ key: 'Number_Plate', label: 'Number Plate' },
	{ key: 'VehicleFuelType', label: 'Vehicle (Fuel Type)' },
	{ key: 'Driver_Name', label: 'Driver Name' },
	{ key: 'Registration_Date', label: 'Created Date' },
	{ key: 'Status', label: 'Status' }
];

const OrderHeaders = [
	{ key: 'OrderType', label: 'Order Type' },
	{ key: 'OrderId', label: 'Order Id' },
	{ key: 'Customer Name', label: 'Customer Name' },
	{ key: 'Payment Method', label: 'Payment Method' },
	{ key: 'Order Amount', label: 'Order Amount' },
	{ key: 'Rider Name', label: 'Driver Name' },
	{ key: 'Order Date', label: 'Date' },
	{ key: 'Order Status', label: 'Order Status' }
];

/**
 * xlsx file generate functionality
 * @param data
 * @param fileName
 */

export function downloadDriverSheet(
	data: any,
	fileName: string,
	header: { key: string; header: string; style?: any }[]
) {
	const workbook: excel.Workbook = new excel.Workbook();
	const sheet: excel.Worksheet = workbook.addWorksheet(fileName);
	sheet.getRow(1).font = { bold: true };
	sheet.columns = header;

	for (const item of data) {
		sheet.addRow({
			Make: item?.DriverDetails?.vehicleMake,
			Model: item?.DriverDetails?.vehicleModel || '-',
			Number_Plate: item?.DriverDetails?.licenseNumber + '-' + item?.orders_end_time,
			VehicleFuelType: item?.DriverDetails?.vehicleType,
			Driver_Name: item?.firstName + ' ' + item?.lastName || '-',
			Registration_Date: new Date(moment(item?.createdAt).format('YYYY-MM-DD')),
			status: data?.isActive ? 'Active' : 'Inactive'
		});
	}

	sheet.columns.forEach((column: any) => {
		const length: any = column.values?.map((v: any) => v.toString().length + 20);
		const maxLength = Math.max(...length.filter((v: number) => typeof v === 'number'));
		column.width = maxLength;
	});
	sheet.getColumn('Registration_Date').width = 20;

	workbook.xlsx.writeBuffer().then(data => {
		const blob = new Blob([data], {
			type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
		});
		saveAs(blob, `${fileName}.xlsx`);
	});
}

export function downloadCustomerSheet(
	data: any,
	fileName: string,
	header: { key: string; header: string; style?: any }[]
) {
	const workbook: excel.Workbook = new excel.Workbook();
	const sheet: excel.Worksheet = workbook.addWorksheet(fileName);
	sheet.getRow(1).font = { bold: true };
	sheet.columns = header;

	for (const item of data) {
		sheet.addRow({
			user_full_name: item?.firstName + ' ' + item?.lastName || '-',
			user_mobile_number: item?.mobileNumber || '-',
			user_email: item?.email || '-',
			TotalOrders: item?.ordersCount || '-',
			user_created_at: new Date(moment(item?.createdAt).format('YYYY-MM-DD')) || '-',
			user_is_active: item?.isActive ? 'Active' : 'Inactive'
		});
	}

	sheet.columns.forEach((column: any) => {
		const length: any = column.values?.map((v: any) => v.toString().length + 20);
		const maxLength = Math.max(...length.filter((v: number) => typeof v === 'number'));
		column.width = maxLength;
	});
	sheet.getColumn('user_created_at').width = 20;

	workbook.xlsx.writeBuffer().then(data => {
		const blob = new Blob([data], {
			type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
		});
		saveAs(blob, `${fileName}.xlsx`);
	});
}

export function downloadOrderSheet(
	data: any,
	fileName: string,
	header: { key: string; header: string; style?: any }[]
) {
	const workbook: excel.Workbook = new excel.Workbook();
	const sheet: excel.Worksheet = workbook.addWorksheet(fileName);
	sheet.getRow(1).font = { bold: true };
	sheet.columns = header;

	for (const item of data) {
		sheet.addRow({
			OrderId: '#OG' + item?.id || '-',
			OrderType: Ordertype[item?.orderType] || '-',
			Customer_Name: item?.user?.name || '-',
			Vendor_Name: item?.vendor?.name || '-',
			Payment_Method: Paymentmode[item?.paymentMode] || '-',
			Order_Amount: item?.grandTotal || '-',
			Rider_Name: item?.driver?.name,

			Order_Date: new Date(moment(item?.createdAt).format('YYYY-MM-DD')) || '-',
			Order_Status: Orderstatus[item?.orderStatus]
		});
	}

	sheet.columns.forEach((column: any) => {
		const length: any = column.values?.map((v: any) => v.toString().length + 20);
		const maxLength = Math.max(...length.filter((v: number) => typeof v === 'number'));
		column.width = maxLength;
	});
	sheet.getColumn('Order_Date').width = 20;

	workbook.xlsx.writeBuffer().then(data => {
		const blob = new Blob([data], {
			type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
		});
		saveAs(blob, `${fileName}.xlsx`);
	});
}

export function downloadrepeatOrderSheet(
	data: any,
	fileName: string,
	header: { key: string; header: string; style?: any }[]
) {
	const workbook: excel.Workbook = new excel.Workbook();
	const sheet: excel.Worksheet = workbook.addWorksheet(fileName);
	sheet.getRow(1).font = { bold: true };
	sheet.columns = header;

	for (const item of data) {
		// console.log(item);

		sheet.addRow({
			OrderId: '#OG' + item?.id || '-',
			OrderType: Ordertype[item?.orderType] || '-',
			Customer_Name: item?.user?.name || '-',
			Vendor_Name: item?.vendor?.name || '-',
			Payment_Method: Paymentmode[item?.paymentMode] || '-',
			Order_Amount: item?.grandTotal || '-',
			Rider_Name: item?.driver?.name,

			Order_Date: new Date(moment(item?.createdAt).format('YYYY-MM-DD')) || '-',
			Order_Status: Orderstatus[item?.orderStatus]
		});
	}

	sheet.columns.forEach((column: any) => {
		const length: any = column.values?.map((v: any) => v.toString().length + 20);
		const maxLength = Math.max(...length.filter((v: number) => typeof v === 'number'));
		column.width = maxLength;
	});
	sheet.getColumn('Order_Date').width = 20;

	workbook.xlsx.writeBuffer().then(data => {
		const blob = new Blob([data], {
			type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
		});
		saveAs(blob, `${fileName}.xlsx`);
	});
}

export function downloadOrderLeakageandDelaySheet(
	data: any,
	fileName: string,
	header: { key: string; header: string; style?: any }[]
) {
	const workbook: excel.Workbook = new excel.Workbook();
	const sheet: excel.Worksheet = workbook.addWorksheet(fileName);
	sheet.getRow(1).font = { bold: true };
	sheet.columns = header;

	for (const item of data) {
		// console.log(item);

		sheet.addRow({
			OrderId: '#OG' + item?.id || '-',
			OrderType: Ordertype[item?.orderType] || '-',
			Customer_Name: item?.user?.name || '-',
			Vendor_Name: item?.vendor?.name || '-',
			Payment_Method: Paymentmode[item?.paymentMode] || '-',
			Order_Amount: item?.grandTotal || '-',
			Rider_Name: item?.driver?.name,

			Order_Date: new Date(moment(item?.createdAt).format('YYYY-MM-DD')) || '-',
			Order_Status: Orderstatus[item?.orderStatus]
		});
	}

	sheet.columns.forEach((column: any) => {
		const length: any = column.values?.map((v: any) => v.toString().length + 20);
		const maxLength = Math.max(...length.filter((v: number) => typeof v === 'number'));
		column.width = maxLength;
	});
	sheet.getColumn('Order_Date').width = 20;

	workbook.xlsx.writeBuffer().then(data => {
		const blob = new Blob([data], {
			type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
		});
		saveAs(blob, `${fileName}.xlsx`);
	});
}

export function downloadVendorSheet(
	data: any,
	fileName: string,
	header: { key: string; header: string; style?: any }[]
) {
	const workbook: excel.Workbook = new excel.Workbook();
	const sheet: excel.Worksheet = workbook.addWorksheet(fileName);
	sheet.getRow(1).font = { bold: true };
	sheet.columns = header;

	for (const item of data) {
		// console.log(item);

		sheet.addRow({
			user_full_name: item?.firstName + ' ' + item?.lastName || '-',
			user_mobile_number: item?.mobileNumber || '-',
			user_email: item?.email || '-',
			user_created_at: new Date(moment(item?.createdAt).format('YYYY-MM-DD')) || '-',
			user_is_active: VendorApprovalStatus[item?.vendorDetails?.profileStatus]
		});
	}

	sheet.columns.forEach((column: any) => {
		const length: any = column.values?.map((v: any) => v.toString().length + 20);
		const maxLength = Math.max(...length.filter((v: number) => typeof v === 'number'));
		column.width = maxLength;
	});
	sheet.getColumn('user_created_at').width = 20;
	workbook.xlsx.writeBuffer().then(data => {
		const blob = new Blob([data], {
			type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
		});
		saveAs(blob, `${fileName}.xlsx`);
	});
}

export function downloadProductSheet(
	data: any,
	fileName: string,
	header: { key: string; header: string; style?: any }[]
) {
	const workbook: excel.Workbook = new excel.Workbook();
	const sheet: excel.Worksheet = workbook.addWorksheet(fileName);
	sheet.getRow(1).font = { bold: true };
	sheet.columns = header;

	for (const item of data) {
		// console.log(item);

		sheet.addRow({
			Product_category: orderType[item?.category] || '-',
			Product_size: item?.size || '-',
			Product_unit: item?.unit || '-',
			Product_created_at: new Date(moment(item?.createdAt).format('YYYY-MM-DD')) || '-',
			Product_is_active: item?.isActive ? 'Active' : 'Inactive'
		});
	}

	sheet.columns.forEach((column: any) => {
		const length: any = column.values?.map((v: any) => v.toString().length + 10);
		const maxLength = Math.max(...length.filter((v: number) => typeof v === 'number'));
		column.width = maxLength;
	});

	sheet.getColumn('Product_created_at').width = 20;

	workbook.xlsx.writeBuffer().then(data => {
		const blob = new Blob([data], {
			type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
		});
		saveAs(blob, `${fileName}.xlsx`);
	});
}

export function downloadTransactionSheet(
	data: any,
	fileName: string,
	header: { key: string; header: string; style?: any }[]
) {
	const workbook: excel.Workbook = new excel.Workbook();
	const sheet: excel.Worksheet = workbook.addWorksheet(fileName);
	sheet.getRow(1).font = { bold: true };
	sheet.columns = header;

	for (const item of data) {

		// const adminProfit =
		// 	(item?.deliveryFees * item?.adminCommissionAmount) / 100;
		// const driverProfit =
		// 	(item?.deliveryFees + item?.driverTip) - adminProfit;

		sheet.addRow({
			order_Id: '#OG' + item?.id || '-',
			order_Date: new Date(moment(item?.createdAt).format('YYYY-MM-DD')) || '-',
			Delivery_TimeSlot: `${item?.startTime} - ${item?.endTime}` || '-',
			Customer_Name: item?.user?.firstName + ' ' + item?.user?.lastName || '-',
			Mobile_Number: `+263 ${item?.driver?.mobileNumber}` || '-',
			Delivery_Address: item?.userAddress?.deliveryLocation || '-',
			Payment_Method: Paymentmode[item?.paymentMode] || '-',
			Product_Category: orderType[item?.orderType] || '-',
			Product_Size: item?.product?.size || "" + ' ' + item?.product?.unit || '-',
			Quantity: orderType[item?.orderType] === "REFILL" ? "-" : item?.quantity || '-',
			Price_Per_Item: item?.product?.vendorProducts[0]?.price || 0,
			Sub_Total: item?.subTotal || 0,
			Transaction_Charges: item?.transactionCharges || 0,
			Delivery_Fee: item?.deliveryFees || 0,
			Driver_Bonus: item?.driverTip || 0,
			Grand_Total: item?.grandTotal || '-',
			Order_Status: Orderstatus[item?.orderStatus] || '-',
			Driver_Name: item?.driver?.firstName + ' ' + item?.driver?.lastName || '-',
			Admin_Commission: item?.adminCommissionPercent || 0,
			Admin_Profit: item?.adminNetProfit || 0,
			Driver_Profit: item?.driverNetProfit || 0,
			// user_full_name: item?.driver?.name || '-',
			// user_mobile_number: item?.driver?.mobileNumber || '-',
			// user_email: item?.driver?.email || '-',
			// Transaction_date: new Date(moment(item?.createdAt).format('YYYY-MM-DD')) || '-',
			// Credit_amount: item?.credit || '-',
			// Debit_amount: item?.debit || '-',
			// Comment: item?.comment || '-'
		});
	}

	sheet.columns.forEach((column: any) => {
		const length: any = column.values?.map((v: any) => v.toString().length + 5);

		const maxLength = Math.max(...length.filter((v: number) => typeof v === 'number'));
		column.width = maxLength;
	});

	sheet.getColumn('order_Date').width = 20;
	workbook.xlsx.writeBuffer().then(data => {
		const blob = new Blob([data], {
			type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
		});
		saveAs(blob, `${fileName}.xlsx`);
	});
}

export const getHourDiff = (
	valuestart: string,
	valuestop: string,
	curr_date = moment().format('YYYY-MM-DD')
) => {
	const t1 = moment(`${curr_date} ${valuestart}`, `YYYY-MM-DD hh:mm A`);
	const t2 = moment(`${curr_date} ${valuestop}`, `YYYY-MM-DD hh:mm A`);
	const duration = moment.duration(t2.diff(t1));

	// const t3 = duration.hours() + ':' + duration.minutes() + ':' + duration.seconds();

	const hours = Math.floor(duration.asHours());
	const minutes = duration.minutes();
	const seconds = duration.seconds();

	const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes
		.toString()
		.padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
	return formattedTime;
};

export const calculateDeletePageNumber = (
	currentPageNumber: number,
	totalItems: number,
	recordsPerPage = process.env.REACT_APP_RECORDS_PER_PAGE as string
) => {
	const totalPages = Math.ceil(totalItems / +recordsPerPage);
	let newPageNumber;

	if (
		currentPageNumber === totalPages &&
		totalItems % +recordsPerPage === 1 &&
		currentPageNumber > 1
	) {
		// If deleting the last item on the last page, move to the previous page
		newPageNumber = currentPageNumber - 1;
	} else {
		newPageNumber = currentPageNumber;
	}

	return newPageNumber;
};

// New download functions for report data structures
export function downloadDriverReportSheet(
	data: any,
	fileName: string,
	header: { key: string; header: string; style?: any }[]
) {
	console.log('downloadDriverReportSheet called with data:', data);
	
	try {
		if (!data || !Array.isArray(data) || data.length === 0) {
			console.error('Invalid driver data for download:', data);
			alert('No driver data available for download');
			return;
		}

		const workbook: excel.Workbook = new excel.Workbook();
		const sheet: excel.Worksheet = workbook.addWorksheet(fileName);
		sheet.getRow(1).font = { bold: true };
		sheet.columns = header;

		for (const item of data) {
			console.log('Processing driver item:', item);
			sheet.addRow({
				driverName: item?.driverName || '-',
				email: item?.email || '-',
				totalOrders: item?.totalOrders || 0,
				totalEarnings: item?.totalEarnings || 0
			});
		}

		sheet.columns.forEach((column: any) => {
			const length: any = column.values?.map((v: any) => v.toString().length + 20);
			const maxLength = Math.max(...length.filter((v: number) => typeof v === 'number'));
			column.width = maxLength;
		});

		workbook.xlsx.writeBuffer().then(data => {
			const blob = new Blob([data], {
				type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
			});
			saveAs(blob, `${fileName}.xlsx`);
			console.log('Driver Excel download completed successfully');
		}).catch(error => {
			console.error('Error creating Excel file:', error);
			alert('Error generating Excel file');
		});
	} catch (error) {
		console.error('Error in downloadDriverReportSheet:', error);
		alert('Error downloading driver report');
	}
}

export function downloadVendorReportSheet(
	data: any,
	fileName: string,
	header: { key: string; header: string; style?: any }[]
) {
	console.log('downloadVendorReportSheet called with data:', data);
	
	try {
		if (!data || !Array.isArray(data) || data.length === 0) {
			console.error('Invalid vendor data for download:', data);
			alert('No vendor data available for download');
			return;
		}

		const workbook: excel.Workbook = new excel.Workbook();
		const sheet: excel.Worksheet = workbook.addWorksheet(fileName);
		sheet.getRow(1).font = { bold: true };
		sheet.columns = header;

		for (const item of data) {
			console.log('Processing vendor item:', item);
			sheet.addRow({
				vendorName: item?.vendorName || '-',
				email: item?.email || '-',
				totalOrders: item?.totalOrders || 0,
				totalEarnings: item?.totalEarnings || 0
			});
		}

		sheet.columns.forEach((column: any) => {
			const length: any = column.values?.map((v: any) => v.toString().length + 20);
			const maxLength = Math.max(...length.filter((v: number) => typeof v === 'number'));
			column.width = maxLength;
		});

		workbook.xlsx.writeBuffer().then(data => {
			const blob = new Blob([data], {
				type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
			});
			saveAs(blob, `${fileName}.xlsx`);
			console.log('Vendor Excel download completed successfully');
		}).catch(error => {
			console.error('Error creating Excel file:', error);
			alert('Error generating Excel file');
		});
	} catch (error) {
		console.error('Error in downloadVendorReportSheet:', error);
		alert('Error downloading vendor report');
	}
}

export function downloadCustomerReportSheet(
	data: any,
	fileName: string,
	header: { key: string; header: string; style?: any }[]
) {
	console.log('downloadCustomerReportSheet called with data:', data);
	
	try {
		if (!data || !Array.isArray(data) || data.length === 0) {
			console.error('Invalid customer data for download:', data);
			alert('No customer order data available for download');
			return;
		}

		const workbook: excel.Workbook = new excel.Workbook();
		const sheet: excel.Worksheet = workbook.addWorksheet(fileName);
		sheet.getRow(1).font = { bold: true };
		sheet.columns = header;

		for (const item of data) {
			console.log('Processing customer order item:', item);
			sheet.addRow({
				OrderId: `#OG${item?.id}`,
				OrderDate: formatDate(item?.scheduleDate, 'DD/MM/YYYY'),
				Customer_Name: `${item?.user?.firstName || ''} ${item?.user?.lastName || ''}`.trim(),
				Driver_Name: `${item?.driver?.firstName || ''} ${item?.driver?.lastName || ''}`.trim(),
				Product_Category: orderType[item?.orderType] || '-',
				Product_Size: `${item?.productSize?.size || ''} ${item?.product?.unit || ''}`.trim(),
				Quantity: orderType[item?.orderType] === 'REFILL' ? '-' : item?.quantity,
				Price: `$ ${item?.subTotal}`,
				Payment_Method: Paymentmode[item?.paymentMode] || '-',
				Delivery_Fee: item?.deliveryFees ?? 0,
				Driver_Bonus: item?.driverTip ?? 0,
				Transaction_Charges: item?.transactionCharges ?? 0,
				Grand_Total: `$ ${item?.grandTotal}`,
				Admin_Profit: `$ ${item?.adminNetProfit || 0}`,
				Order_Status: Orderstatus[item?.orderStatus] || '-'
			});
		}

		sheet.columns.forEach((column: any) => {
			const length: any = column.values?.map((v: any) => v.toString().length + 20);
			const maxLength = Math.max(...length.filter((v: number) => typeof v === 'number'));
			column.width = maxLength;
		});

		workbook.xlsx.writeBuffer().then(data => {
			const blob = new Blob([data], {
				type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
			});
			saveAs(blob, `${fileName}.xlsx`);
			console.log('Customer Excel download completed successfully');
		}).catch(error => {
			console.error('Error creating Excel file:', error);
			alert('Error generating Excel file');
		});
	} catch (error) {
		console.error('Error in downloadCustomerReportSheet:', error);
		alert('Error downloading customer report');
	}
}
